function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import MessageContent from "./content.vue";
import { setMessageReadFun } from "./index";
import { Unread } from "@pt/api/message/enum";
export default defineComponent({
    components: {
        MessageContent: MessageContent
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClose = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var flag;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return setMessageReadFun([
                                {
                                    id: props.data.msg_id,
                                    seq: props.data.seq
                                }, 
                            ]);
                        case 2:
                            flag = _ctx.sent;
                            if (flag) {
                                // eslint-disable-next-line vue/no-mutating-props
                                props.data.status = Unread.Read;
                            }
                            emit("updateMessageList", props.data.msg_id);
                            emit("update:visible", false);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleClose() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            handleClose: handleClose
        };
    }
});
